"use client";
"use client";

// src/components/ui/tooltip.tsx
import { forwardRefIfNeeded } from "@stackframe/stack-shared/dist/utils/react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils.js";
import { jsx } from "react/jsx-runtime";
var TooltipProvider = forwardRefIfNeeded((props, ref) => /* @__PURE__ */ jsx(
  TooltipPrimitive.Provider,
  {
    delayDuration: 0,
    ...props
  }
));
TooltipProvider.displayName = TooltipPrimitive.Provider.displayName;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = forwardRefIfNeeded(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx(
  TooltipPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn(
      "stack-scope z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
};
//# sourceMappingURL=tooltip.js.map